export function constiBenchTextDataAction(data) {
  return {
    type: "GET_CONSTIBENCH_TEXT_DATA",
    payload: { data },
  };
}


export function constiBenchMediaAction(data) {
    return {
      type: "GET_CONSTIBENCH_MEDIA_DATA",
      payload: { data },
    };
  }

